import classNames from 'classnames';
import * as React from 'react';

import css from './BooksLoadingMask.module.scss';

interface Props extends React.HTMLProps<{}> {
  className?: string;
  isLoading: boolean;
}

const BooksLoadingMask = ({ className, isLoading, children }: Props) => {
  const classes = classNames(
    css.BooksLoadingMask,
    {
      [css.isLoading]: isLoading,
    },
    className,
  );

  return (
    <div className={classes}>
      {isLoading && <span className={css.BooksLoadingMask__Loading} />}
      <div className={css.BooksLoadingMask__Mask}>{children}</div>
    </div>
  );
};

export default BooksLoadingMask;
